import type {CompanyVehicle} from "../types";

import {formatPlateForDisplay} from "./format-plate-for-display";

/** Shared label for comboboxes and read-only end-of-patrol display. */
export function formatCompanyVehicleOptionLabel(v: CompanyVehicle): string {
  const name = (v.label ?? v.name ?? "").trim() || (v.unit_number ?? "").trim() || "Vehicle";
  const model = [v.make, v.model].filter(Boolean).join(" ");
  const rest = [model, formatPlateForDisplay(v.plate)].filter(Boolean);
  return rest.length ? `${name} — ${rest.join(" — ")}` : name;
}
